module.exports = __webpack_public_path__ + "static/media/human.2200c68b.png";